import { gql } from "@apollo/client";

export const RESET_CACHE = gql`
  mutation resetCache {
    resetCache
  }
`;
